import { PackInfo } from "modules/packs";

const PackPreviewPage = () => <PackInfo />;

export default PackPreviewPage;
